import React from 'react'

import {Hidden, Card, Chip, withStyles} from 'material-ui'
import classNames from 'classnames'

import SignupForm from '../SignupForm'

const styles = theme => ({
    root: {
        width: 360,
        padding: 10,
        margin: 10,
    },
    rootSm: {
        padding: 4,
        margin: "0 auto",
    }
})

const LandingSignupSmall = withStyles(styles) (
    ({classes, className=''}) => (
        <Card className={classNames(classes.root, className)}>
            <SignupForm />
        </Card>
    )
)

const LandingSignupLarge = withStyles(styles) (
    ({classes, className=''}) => (
        <Card className={classNames(classes.root, className)}>
            <SignupForm />
        </Card>
    )
)

export const LandingSignup = (props) => (
    <div>
        <Hidden smUp><LandingSignupSmall {...props}/></Hidden>
        <Hidden smDown><LandingSignupLarge {...props}/></Hidden>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/landinglib/LandingSignup.jsx